import React from "react";
import { ShieldCheck, CheckCircle2, Clock, FileText } from "lucide-react";
import { useTranslation } from "react-i18next";

const BADGES = [
  { key: "rc_pro", icon: ShieldCheck },
  { key: "cesu",   icon: CheckCircle2 },
  { key: "hours",  icon: Clock },
  { key: "quote",  icon: FileText },
];

const TrustBadges = ({ className = "" }) => {
  const { t } = useTranslation();
  return (
    <div className={`grid grid-cols-2 lg:grid-cols-4 gap-3 ${className}`}>
      {BADGES.map(({ key, icon: Icon }) => (
        <div
          key={key}
          className="flex items-center gap-2.5 rounded-2xl border border-slate-200 bg-white px-4 py-3 shadow-sm"
        >
          <Icon className="h-5 w-5 text-brand-green shrink-0" />
          <span className="text-xs font-semibold text-slate-700 leading-tight">
            {t(`trust_badges.${key}`)}
          </span>
        </div>
      ))}
    </div>
  );
};

export default TrustBadges;
